export const V1_REDIS_GET_KEY = '/view/v1/redis-keys/get-by-key'
export const V1_REDIS_GET_GROUP = '/view/v1/redis-keys/get-group-key'
export const V1_REDIS_GET_KEY_IN_GROUP = '/view/v1/redis-keys/get-key-in-group'
export const V1_REDIS_MENU_GET_GROUP = '/view/v1/instance/redisson/menu/get-menu-by-group'
